import {
  APIInterfaceI,
  buildRequest,
  PaginationT,
} from '.';

class IPNetwork implements APIInterfaceI {
  getAll = (pagination: PaginationT) => buildRequest(
    'GET',
    `/pools?cursor=${pagination.cursor}&limit=${pagination.limit}`,
  );

  getOne = (targetId: string) => buildRequest(
    'GET',
    `/pools/${targetId}`,
  );

  register = (formData: any) => buildRequest(
    'POST',
    '/pools', formData,
  );

  delete = (targetId: string) => buildRequest(
    'DELETE',
    `/pools/${targetId}`,
  );

  update = (targetId: string, data: any) => buildRequest(
    'PUT',
    `/pools/${targetId}`,
    data,
  );

  downloadVPNAgent = (targetId: string, architecture: string) => buildRequest(
    'GET',
    `/downloadnbapackage?poolID=${targetId}&arch=${architecture}`,
  );
}

export default IPNetwork;
